import { setBuildingIndexes } from "@project-rouge/rg-core";
const pipeSetBuildingIndexes = ([parent]) => {
	setBuildingIndexes(parent);
	return [parent, void 0];
};
export { pipeSetBuildingIndexes };

//# sourceMappingURL=index180.js.map